import { request } from '@/define'

import { IResponseData } from '../request'

export class wxDownloadApis {
    /** 获取游戏列表 */
    getWechatGameByPage(params: { gameName: string; gameType: string; currentPage: string }) {
        return request.post('/web/game/getWechatGameByPage', params)
    }

    /** 获取游戏详情 */
    getWechatGameDetail(params: { gameId: string }): Promise<IResponseData> {
        return request.post('/web/game/getWechatGameDetail', params)
    }
}
